
<template>
<AppLayout>
  <div class="inventory">
    <section id="purchase-request-view">
      <div class="container">
        <h6 class="fw-bold">Manage Purchase Request - {{ purchaseRequest.requestNumber }}</h6>
        <div style="margin-top:10px;">
          <div class="form">
            <div class="row">
              <div class="fw-bold">1. Requester Details</div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Name</label>
                  <input type="text" readonly class="form-control" :value="purchaseRequest.requesterUser?.name">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Position</label>
                  <input type="text" readonly class="form-control" :value="purchaseRequest.requesterUser?.designation">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Department</label>
                  <input type="text" readonly class="form-control" :value="purchaseRequest.requesterUser?.Permission?.deparment?.name">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Email</label>
                  <input type="text" readonly class="form-control" :value="purchaseRequest.requesterUser?.email">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Date Requested</label>
                  <input type="text" readonly class="form-control" :value="formatDate(purchaseRequest.createdAt, true)">
                </div>
              </div>
            </div>
          </div>

          <div class="form">
            <div class="row mt-3">
              <div class="fw-bold">2. Request Information</div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Status</label>
                  <input type="text" readonly class="form-control" :value="purchaseRequest.status">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Priority</label>
                  <input type="text" readonly class="form-control" :value="purchaseRequest.priority">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Expected Date</label>
                  <input type="text" readonly class="form-control" :value="formatDate(purchaseRequest.expectedDate)">
                </div>
              </div>
              <div class="col-md-2" v-if="purchaseRequest.vehicles && purchaseRequest.vehicles.length > 0">
                <div class="form-group">
                  <label>Vehicles</label>
                  <div class="form-control" style="height:auto; min-height:38px; display:flex; flex-wrap:wrap; gap:4px; align-items:center;">
                    <span
                      v-for="v in purchaseRequest.vehicles"
                      :key="v.id"
                      class="badge bg-secondary"
                    >{{ formatVehicleLabel(v) }}</span>
                  </div>
                </div>
              </div>

              <!--
              <div class="col-md-2">
                <div class="form-group">
                  <label>Warehouse</label>
                  <input type="text" readonly class="form-control" :value="purchaseRequest.warehouse?.name">
                </div>
              </div> -->
              <div class="col-md-4">
                <div class="form-group">
                  <label>Purpose</label>
                  <input type="text" readonly class="form-control" :value="purchaseRequest.purpose">
                </div>
              </div>
            </div>
          </div>

          <!--
          <div class="form">
            <div class="row mt-3">
              <div class="fw-bold">3. Requested To</div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Name</label>
                  <input type="text" readonly class="form-control" :value="purchaseRequest.requestedToUser?.name">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Position</label>
                  <input type="text" readonly class="form-control" :value="purchaseRequest.requestedToUser?.designation">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Department</label>
                  <input type="text" readonly class="form-control" :value="purchaseRequest.requestedToUser?.Permission?.deparment?.name">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Email</label>
                  <input type="text" readonly class="form-control" :value="purchaseRequest.requestedToUser?.email">
                </div>
              </div>
            </div>
          </div>-->

          <div class="form">
            <div class="row mt-3">
                <div class="fw-bold">4. Items Requested</div>
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Item</th>
                    <th>Code</th>
                    <th>Unit</th>
                    <th>Qty Requested</th>
                    <th>Status</th>
                    <th>Qty To Purchase</th>
                    <th v-if="anyItemHasVehicles">Vehicles</th>
                    <th>Request Description</th>
                    <th>Product Description</th>
                    <th>Comment</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody v-if="purchaseRequest.items?.length > 0">
                  <tr v-for="(item, index) in purchaseRequest.items" :key="item.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.product?.name || item.service?.name || '—' }}</td>
                    <td>{{ item.product?.code || item.service?.code || '—' }}</td>
                    <td>{{ item.product?.unit?.unit || item.service?.unit?.name || '—' }}</td>
                    <td>
                      <span v-if="(item.status || '').toString().toUpperCase() === 'DEFERRED'">N/A</span>
                      <span v-else>{{ item.quantity }}</span>
                    </td>
                    <td>
                      <span class="badge" :class="getItemStatusClass(item.status)">{{ item.status || 'PENDING' }}</span>
                    </td>
                    <td>
                      <div v-if="(item.status || '').toString().toUpperCase() === 'PROCESSED'">
                        <span class="processed-qty">{{ item.quantityProcessed ?? item.processedQuantity ?? 0 }}</span>
                      </div>
                      <div v-else>
                        <input type="number" min="0" :max="item.quantity" class="form-control" v-model.number="item.processedQuantity" :id="'processedQty'+item.id" />
                        <div v-if="processingProgress[item.id] != null" class="mt-2">
                          <div class="progress" style="height:6px;">
                            <div class="progress-bar" role="progressbar" :style="{ width: processingProgress[item.id] + '%' }" :aria-valuenow="processingProgress[item.id]" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td v-if="anyItemHasVehicles">
                      <span v-if="item.vehicles && item.vehicles.length > 0">
                        <span v-for="v in item.vehicles" :key="v.id" class="badge bg-light text-dark me-1">{{ formatVehicleLabel(v) }}</span>
                      </span>
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td>
                      {{ item.description || '—' }}
                    </td>
                    <td>
                      {{ item.productDescription || '—' }}
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': requiresComment(item) && !hasValidComment(item) }"
                        v-model="item.processingComment"
                        :id="'comment'+item.id"
                        :placeholder="requiresComment(item) ? 'Required when qty reduced' : ''"
                        :disabled="(item.status || '').toString().toUpperCase() === 'PROCESSED'"
                      />
                    </td>
                    <td class="text-end">
                      <div style="display:flex;gap:8px;justify-content:flex-end;">
                        <button v-if="hasPurchaseRequestProcess" class="btn btn-warning btn-sm" style="min-width:120px;" @click="processRequest(item.id)" :disabled="!canCompleteItem(item)" :title="requiresComment(item) && !hasValidComment(item) ? 'Comment required when quantity is reduced' : ''">
                          <span v-if="processingItems.includes(item.id)">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            &nbsp;Processing...
                          </span>
                          <span v-else>Complete</span>
                        </button>
                        <!--<button class="btn btn-secondary btn-sm" style="min-width:120px;" @click="deferRequest(item.id)" :disabled="!canProcess() || (item.status || '').toString().toUpperCase() === 'DEFERRED' || processingItems.includes(item.id)">
                          <span v-if="processingItems.includes(item.id)">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            &nbsp;Deferring...
                          </span>
                          <span v-else>Defer</span>
                        </button>-->
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>

                  <tr><td colspan="9" class="text-center">No items found</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="form-actions ">
            <div class="btn-group">
              <button v-if="hasPurchaseRequestProcess && allItemsActioned()" @click="processAllAndCreateTender" class="btn btn-style-2" :disabled="processingAll">
                <span v-if="processingAll">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  &nbsp;Processing...
                </span>
                <span v-else>
                  <i class="fas fa-cogs"></i> Process Request
                </span>
              </button>
            </div>
          </div>

          <!-- Reject Modal -->
          <div v-if="showRejectModal" class="modal-backdrop">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Reject Purchase Request</h5>
                  <button @click="closeRejectModal" class="btn-close"></button>
                </div>
                <div class="modal-body">
                  <div class="form-group">
                    <label for="rejectReason">Reason for Rejection</label>
                    <textarea v-model="rejectForm.reason" id="rejectReason" class="form-control" rows="4" placeholder="Please provide a reason for rejecting this request..."></textarea>
                  </div>
                </div>
                <div class="modal-footer">
                  <button @click="closeRejectModal" class="btn btn-secondary">Cancel</button>
                  <button @click="confirmRejectRequest" class="btn btn-danger" :disabled="!rejectForm.reason.trim()">Reject Request</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</AppLayout>
</template>

<script>
import AppLayout from '@/components/AppLayout.vue'

export default {
  name: 'ViewPurchaseRequest',
  components: {
    AppLayout
  },
  data() {
    return {
      token: JSON.parse(localStorage.getItem('access_token')),
      purchaseRequest: {
        items: [],
        approvals: []
      },
      processingItems: [],
      processingProgress: {},
        processingAll: false,
      showRejectModal: false,
      rejectForm: {
        reason: ''
      }
    }
  },
  computed: {
    anyItemHasVehicles() {
      return (this.purchaseRequest.items || []).some(i => Array.isArray(i.vehicles) && i.vehicles.length > 0)
    },
    anyItemHasReason() {
      return (this.purchaseRequest.items || []).some(i => i.description && i.description.trim())
    },
    hasPurchaseRequestProcess() {
      try {
        const cached = localStorage.getItem('user_cache')
        if (cached) {
          const user = JSON.parse(cached)
          return user?.Permission?.purchaseRequestProcess === true
        }

        const raw = localStorage.getItem('user')
        if (raw) {
          const user = JSON.parse(raw)
          return user?.Permission?.purchaseRequestProcess === true
        }
      } catch (e) {
        return false
      }

      return false
    }
  },
  mounted() {
    this.loadPurchaseRequest()
  },
  methods: {
    allItemsActioned() {
      if (!this.purchaseRequest.items || !this.purchaseRequest.items.length) return false
      return this.purchaseRequest.items.every(i => {
        const s = (i.status || '').toString().toUpperCase()
        return s === 'PROCESSED' || s === 'DEFERRED'
      })
    },

    getItemProcessedQty(item) {
      return Number(item.processedQuantity ?? item.quantityProcessed ?? 0)
    },
    formatVehicleLabel(vehicle) {
      if (!vehicle) return '—'
      const details = [vehicle.make, vehicle.model].filter(Boolean).join(' ')
      return details ? `${vehicle.plateNumber} — ${details}` : (vehicle.plateNumber || '—')
    },
    /** Returns true when processed qty < requested qty — comment is required before completing */
    requiresComment(item) {
      if (!item) return false
      const requested = Number(item.quantity || 0)
      const processed = Number(item.processedQuantity ?? item.quantityProcessed ?? 0)
      return processed < requested && processed > 0
    },
    hasValidComment(item) {
      return ((item?.processingComment || '').trim()).length > 0
    },
    canCompleteItem(item) {
      if (!item || (item.status || '').toString().toUpperCase() === 'PROCESSED') return false
      if (!this.hasPurchaseRequestProcess) return false
      if (!this.canProcess()) return false
      if (this.processingItems.includes(item.id)) return false
      if (this.requiresComment(item) && !this.hasValidComment(item)) return false
      return true
    },
    showToast(type, message) {
      try {
        if (this.$toast && typeof this.$toast[type] === 'function') {
          this.$toast[type](message)
        } else {
          if (type === 'error') console.error(message)
          else console.log(message)
        }
      } catch (e) {
        if (type === 'error') console.error(message)
        else console.log(message)
      }
    },
    async loadPurchaseRequest() {
      try {
        const res = await fetch(process.env.VUE_APP_URL + `/purchase-requests/${this.$route.params.id}`, {
          headers: {
            'Accept': 'application/json',
            'Authorization': this.token ? `Bearer ${this.token}` : ''
          }
        });
        if (!res.ok) throw new Error('Failed to load purchase request');
        const data = await res.json();
        const pr = data.data || data;
        // Normalize backend field names to match template
        pr.requestNumber = pr.purchaseRequestNo || pr.requestNumber
        pr.requesterUser = pr.requestedBy || pr.requestedByUser || pr.requesterUser || null
        pr.requestedToUser = pr.requestedTo || pr.requestedToUser || pr.requested_to || null
        pr.priority = pr.priority || pr.urgency || null
        pr.expectedDate = pr.expectedDeliveryDate || pr.expectedDate || null
        pr.purpose = pr.purpose || pr.justification || null
        // Ensure items have local fields used by the template
        if (Array.isArray(pr.items)) {
          pr.items.forEach(item => {
            // prefer the originally requested quantity when pre-filling
            const requested = Number(item.quantity ?? item.quantityProcessed ?? 0)
            const existing = item.processedQuantity ?? item.quantityProcessed
            if (existing == null || Number(existing) === 0) {
              item.processedQuantity = requested
            } else {
              // keep existing but ensure numeric
              item.processedQuantity = Number(existing)
            }
            if (item.processingComment == null) item.processingComment = ''
          })
        }
        this.purchaseRequest = pr;
      } catch (error) {
        console.error('Error loading purchase request:', error);
        this.showToast('error', 'Failed to load purchase request');
        this.$router.push('/transaction/purchase-request');
      }
    },
    
    getStatusClass(status) {
      const classes = {
        DRAFT: 'bg-secondary',
        PENDING: 'bg-warning',
        APPROVED: 'bg-success',
        PROCESSING: 'bg-info',
        COMPLETED: 'bg-primary',
        REJECTED: 'bg-danger'
      }
      return classes[status] || 'bg-secondary'
    },
    
    getPriorityClass(priority) {
      const classes = {
        LOW: 'bg-secondary',
        MEDIUM: 'bg-warning',
        HIGH: 'bg-danger',
        URGENT: 'bg-danger urgent'
      }
      return classes[priority] || 'bg-secondary'
    },
    
    getItemStatusClass(status) {
      const classes = {
        PENDING: 'bg-warning',
        PROCESSING: 'bg-info',
        PROCESSED: 'bg-success',
        DEFERRED: 'bg-secondary',
        CANCELLED: 'bg-danger'
      }
      return classes[status] || 'bg-warning'
    },

    async deferRequest(itemId) {
      if (!this.canProcess()) return this.showToast('error', 'Purchase request must be approved before deferring items')

      try {
        const item = this.purchaseRequest.items.find(i => i.id === itemId)
        if (!item) return this.showToast('error', 'Item not found')

        // mark as processing for this item
        if (!this.processingItems.includes(itemId)) this.processingItems.push(itemId)

        const payload = {
          purchaseRequestId: this.purchaseRequest.id,
          items: [
            {
              itemId: item.id,
              quantityProcessed: null,
              processingComment: item.processingComment || '',
              status: 'DEFERRED'
            }
          ]
        }

        const res = await fetch((process.env.VUE_APP_URL || '') + '/purchase-requests/process', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': this.token ? `Bearer ${this.token}` : ''
          },
          body: JSON.stringify(payload)
        })

        if (!res.ok) throw new Error('Failed to defer item')

        this.showToast('success', 'Item deferred')
        await this.loadPurchaseRequest()
      } catch (error) {
        console.error('Error deferring item:', error)
        this.showToast('error', 'Failed to defer item')
      } finally {
        this.processingItems = this.processingItems.filter(id => id !== itemId)
      }
    },
    
    canEdit() {
      return this.purchaseRequest.status === 'PENDING' || this.purchaseRequest.status === 'DRAFT'
    },
    
    canProcess() {
      const s = (this.purchaseRequest.status || '').toString().toUpperCase()
      return s === 'APPROVED' || s === 'PROCESSING'
    },
    
    canApprove() {
      return this.purchaseRequest.status === 'PENDING';
    },

    canReject() {
      return this.purchaseRequest.status === 'PENDING';
    },
    async processRequest(itemId) {
      // Ensure purchase request is approved before processing
      if (!this.canProcess()) return this.showToast('error', 'Purchase request must be approved before processing')

      const item = this.purchaseRequest.items.find(i => i.id === itemId)
      if (!item) return this.showToast('error', 'Item not found')

      // When quantity processed < requested, comment is required
      if (this.requiresComment(item) && !this.hasValidComment(item)) {
        return this.showToast('error', 'A comment is required when the quantity to purchase is less than the quantity requested')
      }

      // Process a single item inline and then reload
      let progTimer = null
      try {

        // mark as processing for this item
        if (!this.processingItems.includes(itemId)) this.processingItems.push(itemId)
        // start a visual progress indicator (indeterminate up to 90%)
        this.processingProgress[itemId] = 0
        progTimer = setInterval(() => {
          const cur = Number(this.processingProgress[itemId] || 0)
          if (cur < 90) this.processingProgress[itemId] = Math.min(90, cur + Math.floor(Math.random() * 10) + 5)
        }, 200)

        const payload = {
          purchaseRequestId: this.purchaseRequest.id,
          items: [
            {
              itemId: item.id,
              quantityProcessed: item.processedQuantity || item.quantity,
              processingComment: item.processingComment || '',
              status: 'PROCESSED'
            }
          ]
        }

        const res = await fetch((process.env.VUE_APP_URL || '') + '/purchase-requests/process', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': this.token ? `Bearer ${this.token}` : ''
          },
          body: JSON.stringify(payload)
        })

        if (!res.ok) throw new Error('Failed to process item')

        this.showToast('success', 'Item processed successfully')

        // Reload the purchase request to show processed quantities; do not redirect here.
        await this.loadPurchaseRequest()
      } catch (error) {
        console.error('Error processing item:', error)
        this.showToast('error', 'Failed to process item')
      } finally {
        // stop progress timer and mark complete briefly
        if (progTimer) {
          clearInterval(progTimer)
          progTimer = null
        }
        this.processingProgress[itemId] = 100
        setTimeout(() => { delete this.processingProgress[itemId] }, 350)
        this.processingItems = this.processingItems.filter(id => id !== itemId)
      }
    },

    async processAllAndCreateTender() {
      // Process all items that have a positive processed quantity, validate limits,
      // and if none to process but all items already actioned, proceed to create tender.
      try {
        this.processingAll = true
        const itemsToProcess = this.purchaseRequest.items
          .map(i => ({
            item: i,
            qty: Number(i.processedQuantity ?? i.quantityProcessed ?? 0)
          }))
          .filter(x => x.qty > 0)
          .map(x => ({ itemId: x.item.id, quantityProcessed: x.qty, processingComment: x.item.processingComment || '', status: 'PROCESSED' }))

        // Validate quantities do not exceed requested (no comment validation on Process Request)
        for (const it of itemsToProcess) {
          const original = this.purchaseRequest.items.find(i => i.id === it.itemId)
          const requested = Number(original.quantity || 0)
          if (it.quantityProcessed > requested) {
            return this.showToast('error', `Cannot process more than requested for ${original.product?.name || original.service?.name || 'item'}`)
          }
          if (it.quantityProcessed <= 0) {
            return this.showToast('error', 'Processed quantity must be greater than zero')
          }
        }

        if (itemsToProcess.length === 0) {
          // If nothing new to process, but all items are already actioned (processed/deferred), allow redirect
          if (this.allItemsActioned()) {
            this.$router.push({ path: '/admin/tenders/add', query: { purchaseRequestId: this.purchaseRequest.id } })
            return
          }
          return this.showToast('error', 'No items marked for processing')
        }

        const payload = { purchaseRequestId: this.purchaseRequest.id, items: itemsToProcess }

        const res = await fetch((process.env.VUE_APP_URL || '') + '/purchase-requests/process', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': this.token ? `Bearer ${this.token}` : ''
          },
          body: JSON.stringify(payload)
        })

        // parse JSON safely
        let body = null
        const ct = res.headers.get('content-type') || ''
        if (ct.includes('application/json')) {
          try { body = await res.json() } catch (e) { body = null }
        }

        if (!res.ok) {
          const msg = (body && (body.message || body.error)) || 'Failed to process items'
          if (body && Array.isArray(body.errors) && body.errors.length) {
            body.errors.forEach(err => this.showToast('error', err.message || err))
          } else {
            this.showToast('error', msg)
          }
          throw new Error(msg)
        }

        // Success: prefer detailed per-item messages when provided
        if (body) {
          // Top-level errors
          if (Array.isArray(body.errors) && body.errors.length) {
            body.errors.forEach(err => this.showToast('error', err.message || err))
          }

          const data = body.data || body
          if (data && Array.isArray(data.itemResults) && data.itemResults.length) {
            data.itemResults.forEach(r => {
              if (r.success) this.showToast('success', r.message || `Item ${r.itemId} processed`)
              else this.showToast('error', r.message || `Failed to process item ${r.itemId}`)
            })
          } else if (data && typeof data.processedCount === 'number') {
            this.showToast('success', `${data.processedCount} items processed — please create a tender`)
          } else if (body.message) {
            this.showToast('success', body.message)
          } else {
            this.showToast('success', 'Items processed — please create a tender')
          }
        } else {
          this.showToast('success', 'Items processed — please create a tender')
        }

        this.$router.push({ path: '/admin/tenders/add', query: { purchaseRequestId: this.purchaseRequest.id } })
      } catch (error) {
        console.error('Error processing items:', error)
        this.showToast('error', 'Failed to process items')
      }
      finally {
        this.processingAll = false
      }
    },
    
    async approveRequest() {
      try {
        const res = await fetch(process.env.VUE_APP_URL + `/purchase-requests/${this.purchaseRequest.id}/approve`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': this.token ? `Bearer ${this.token}` : ''
          },
          body: JSON.stringify({})
        });

        // parse JSON safely (handle empty/204 responses)
        let body = null;
        const ct = res.headers.get('content-type') || '';
        if (ct.includes('application/json')) {
          try { body = await res.json(); } catch(e) { body = null }
        }

        if (!res.ok) {
          const msg = (body && (body.message || body.error)) || 'Failed to approve purchase request';
          throw new Error(msg);
        }

        this.showToast('success', 'Purchase request approved successfully');

        // If server returned the updated purchase request, use it to update UI immediately
        const pr = body && (body.data || body);
        if (pr) {
          pr.requestNumber = pr.purchaseRequestNo || pr.requestNumber
          pr.requesterUser = pr.requestedBy || pr.requestedByUser || pr.requesterUser || null
          pr.requestedToUser = pr.requestedTo || pr.requestedToUser || pr.requested_to || null
          pr.priority = pr.priority || pr.urgency || null
          pr.expectedDate = pr.expectedDeliveryDate || pr.expectedDate || null
          this.purchaseRequest = pr
        } else {
          // fallback: reload from server
          await this.loadPurchaseRequest();
        }
      } catch (error) {
        console.error('Error approving request:', error);
        this.showToast('error', 'Failed to approve purchase request');
      }
    },
    
    openRejectModal() {
      this.rejectForm.reason = ''
      this.showRejectModal = true
    },
    
    closeRejectModal() {
      this.showRejectModal = false
      this.rejectForm.reason = ''
    },
    
    async confirmRejectRequest() {
      try {
        const res = await fetch(process.env.VUE_APP_URL + `/purchase-requests/${this.purchaseRequest.id}/reject`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': this.token ? `Bearer ${this.token}` : ''
          },
          body: JSON.stringify({ reason: this.rejectForm.reason })
        });
        if (!res.ok) throw new Error('Failed to reject purchase request');
        this.showToast('success', 'Purchase request rejected');
        this.closeRejectModal();
        this.loadPurchaseRequest();
      } catch (error) {
        console.error('Error rejecting request:', error);
        this.showToast('error', 'Failed to reject purchase request');
      }
    },
    
    async exportToPdf() {
      try {
        this.showToast('info', 'Generating PDF...');
        const res = await fetch(process.env.VUE_APP_URL + `/purchase-requests/${this.purchaseRequest.id}/pdf`, {
          headers: {
            'Accept': 'application/pdf',
            'Authorization': this.token ? `Bearer ${this.token}` : ''
          }
        });
        if (!res.ok) throw new Error('Failed to export PDF');
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `purchase-request-${this.purchaseRequest.requestNumber}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error exporting PDF:', error);
        this.showToast('error', 'Failed to export PDF');
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.status-badge, .priority-badge {
  padding: 6px 13px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
}

.info-section {
  background: white;
  margin-bottom: 30px;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.info-section h5 {
  margin: 0 0 20px 0;
  color: #1F3B73;
  border-bottom: 2px solid #1F3B73;
  padding-bottom: 8px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.info-item {
  display: flex;
  flex-direction: column;
}

.info-item.full-width {
  grid-column: 1 / -1;
}

.info-item label {
  font-weight: 600;
  color: #666;
  font-size: 11px;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.info-item span {
  font-size: 13px;
  color: #333;
}

.items-table {
  background: white;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.table {
  margin: 0;
}

.table th {
  background-color: #1F3B73;
  color: white;
  border: none;
  padding: 11px;
  font-size: 13px;
}

.table td {
  padding: 11px;
  vertical-align: middle;
}

.product-info p {
  font-size: 13px;
  color: #1F3B73;
}

.quantity {
  font-weight: bold;
  font-size: 13px;
  color: #1F3B73;
}

.processed-qty {
  font-weight: bold;
  color: #28a745;
}

.item-notes {
  font-size: 11px;
  color: #666;
}

.approval-timeline {
  position: relative;
}

.approval-item {
  display: flex;
  margin-bottom: 20px;
  padding: 15px;
  border-radius: 6px;
  background: #f8f9fa;
  border-left: 4px solid #ddd;
}

.approval-item.APPROVED {
  border-left-color: #28a745;
  background: #f1f9f3;
}

.approval-item.REJECTED {
  border-left-color: #dc3545;
  background: #fdf2f2;
}

.approval-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  background: #ddd;
  color: white;
}

.approval-item.APPROVED .approval-icon {
  background: #28a745;
}

.approval-item.REJECTED .approval-icon {
  background: #dc3545;
}

.approval-content {
  flex: 1;
}

.approval-header {
  display: flex;
  justify-content: between;
  align-items: center;
  margin-bottom: 5px;
}

.approval-decision {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 11px;
  text-transform: uppercase;
  font-weight: bold;
  margin-left: auto;
}

.approval-decision.APPROVED {
  background: #28a745;
  color: white;
}

.approval-decision.REJECTED {
  background: #dc3545;
  color: white;
}

.approval-comments {
  background: white;
  padding: 10px;
  border-radius: 4px;
  margin-top: 8px;
  font-size: 13px;
  border: 1px solid #e9ecef;
}

.processing-notes {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 6px;
  border-left: 4px solid #007bff;
}

.form-actions {
  margin-top: 40px;
  margin-bottom: 40px;
  padding-top: 30px;
  border-top: 2px solid #e9ecef;
  display: flex;
  justify-content: end;
}

.btn-group {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.btn-group .btn {
  min-width: 140px;
  padding: 11px 20px;
}

.badge {
  font-size: 11px;
  padding: 4px 8px;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-dialog {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  padding: 15px 20px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn-close {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

.urgent {
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0.7; }
}
</style>